import Image, { StaticImageData } from 'next/legacy/image';

import { BodyRegular } from '@common/body';
import { H4 } from '@common/headline';
import { Overline } from '@common/overline';

type Props = {
  image: StaticImageData;
  altText: string;
  title: string;
  body?: string | JSX.Element;
  supertitle?: string;
  textAlign?: 'start' | 'center';
};

export const ImageWithExplainerMobile = ({
  image,
  altText,
  title,
  body,
  supertitle,
  textAlign = 'center',
}: Props): JSX.Element => (
  <div
    className={`flex flex-col items-center ${
      textAlign === 'start'
        ? 'max-w-[312px] text-start'
        : 'max-w-[351px] text-center'
    }`}
  >
    <div className="relative h-[290px] w-[312px] overflow-hidden rounded-3xl">
      <Image layout="fill" objectFit="cover" src={image} alt={altText} />
    </div>
    {supertitle && (
      <div className="mt-6 w-full text-dawn-blue">
        <Overline>{supertitle}</Overline>
      </div>
    )}
    <div className={`w-full text-mono-white ${supertitle ? 'mt-2' : 'mt-8'}`}>
      <H4>{title}</H4>
    </div>
    {body && (
      <div className="mt-2 w-full text-blue-200">
        <BodyRegular>{body}</BodyRegular>
      </div>
    )}
  </div>
);
